module.exports = __webpack_public_path__ + "1ad6e121a5d4608888caa3bb74f4207c.fbx";